export function isAnchor(href: string): boolean {
  return href.includes('#')
}
